import { ForgotPasswordView } from '@/views/ForgotPasswordView';

const ForgotPasswordPage = () => <ForgotPasswordView />;
export default ForgotPasswordPage;
